// extracted by mini-css-extract-plugin
module.exports = {"threeDWithProBadge":"styles-module__threeDWithProBadge___2OIKq","proBadge":"styles-module__proBadge___1mNzL"};